<template>
  <div class="has-text-centered">
    <button v-if="!isEmpty(dataProvider) && ((!isEmpty(count_items) && count_items < dataProvider.page.total) || (dataProvider.page.current < dataProvider.page.count))" class="button is-small is-rounded" @click.prevent="load">
      <i class="fa fa-repeat"></i>&nbsp;Muat lebih
    </button>
  </div>
</template>

<script>
export default {
  props: {
    count_items: {
      type: [Number, String],
      default: null
    },
    infinity_scroll: {
      type: Boolean,
      default: false
    },
    dataProvider: {
      type: Object,
      default: () => {
        return {
          criterion: [],
          page: {
            count: 0,
            current: 1,
            limit: 15,
            next: -1,
            previous: -1,
            total: 0
          },
          sort: []
        }
      }
    },
    setDataProvider: {
      type: Function,
      default: null
    },
    clickHandler: {
      type: Function,
      default: () => {}
    }
  },

  mounted() {
    const vm = this

    window.addEventListener("scroll", this.onScroll)
  },

  watch: {
    is_visible(val) {
      const vm = this;

      if (val && this.infinity_scroll && !this.isEmpty(this.dataProvider) && ((!this.isEmpty(this.count_items) && this.count_items < this.dataProvider.page.total) || (this.dataProvider.page.current < this.dataProvider.page.count) || this.dataProvider.page.next != -1)) {
        this.load()
      }
    },
  },

  data() {
    return {
      view_timer: 0,
      view_interval: null,
      is_visible: false,
    }
  },

  methods: {
    load() {
      if (!this.isEmpty(this.setDataProvider)) {
        let dataProvider = _.cloneDeep(this.dataProvider);
        dataProvider.page['current'] = dataProvider.page.next;

        this.setDataProvider(dataProvider);
      } else {
        this.dataProvider.page['current'] = this.dataProvider.page.next;
      }

      this.clickHandler();
    },
    onScroll(e) {
      const rect = this.$el.getBoundingClientRect();
      let viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
      this.is_visible = !(rect.bottom < 0 || rect.top - viewHeight >= 0);
    },
  }
}
</script>
